// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notes-list-container[data-v-267d76ce] {\n  background: #f9fbfb;\n  padding: 0.5rem 1.5rem;\n}\n.notes-border[data-v-267d76ce] {\n  border-bottom: 1px solid #e4e4e4;\n}\n", ""]);
// Exports
module.exports = exports;
